import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import classNames from 'classnames';
import { Icon } from '../../../components';

import css from './SignupWizard.module.css';

const SignupStepHeader = props => {
  const { stepNumber, titleKey, onBack, className } = props;

  const classes = classNames(css.stepHeader, className);

  return (
    <div className={classes}>
      <button type="button" className={css.backButton} onClick={onBack}>
        <Icon name="chevronLeft" size={24} className={css.backArrow} />
        <div className={css.stepContent}>
          <span className={css.stepIndicator}>
            <FormattedMessage id="SignupWizard.stepLabel" values={{ step: stepNumber }} />
          </span>
          {titleKey && (
            <h1 className={css.stepTitle}>
              <FormattedMessage id={titleKey} />
            </h1>
          )}
        </div>
      </button>
    </div>
  );
};

SignupStepHeader.defaultProps = {
  className: null,
  onBack: null,
  titleKey: null,
};

SignupStepHeader.propTypes = {
  className: PropTypes.string,
  stepNumber: PropTypes.number.isRequired,
  titleKey: PropTypes.string,
  onBack: PropTypes.func,
};

export default SignupStepHeader;
